<template>
    <rkm-alert>
        <rkm-row>
            <rkm-col cols="6">
                <span>
                    <strong>Paciente:</strong> {{ paciente.nome }} <strong v-if="paciente.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL"> ({{ paciente.nomeSocial }})</strong>
                </span>
            </rkm-col>

            <rkm-col cols="6">
                <span>
                    <strong>Nome da mãe:</strong> {{ paciente.nomeMae || 'Não informado' }}
                </span>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <span>
                    <strong>Data de nascimento:</strong> {{ paciente.dataNascimento || 'Não informado' }}
                </span>
            </rkm-col>

            <rkm-col cols="3">
                <span>
                    <strong>CPF:</strong> {{ paciente.cpf || 'Não informado' }}
                </span>
            </rkm-col>

            <rkm-col cols="3">
                <span>
                    <strong>CNS:</strong> {{ paciente.cns || 'Não informado' }}
                </span>
            </rkm-col>
        </rkm-row>
    </rkm-alert>
</template>

<script>
// Enums
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    data:() => ({
        enums:{ preferenciaNome }
    }),
    props: {
        paciente: {required: true, type: Object},
    },
}
</script>